






































import axios from 'axios'
import {
  apiV1AdminRecommendPath,
  apiV1AdminRecommendsPath,
} from '@/rails/routes'
import { Component } from 'vue-property-decorator'
import { DataTableHeader } from 'vuetify'
import PageBase, {BreadCrumb} from '@/pages/page-base'
import Recommend, {IRecommend} from '@/models/Recommend'

@Component
export default class RecommendIndex extends PageBase {
  headers: Array<DataTableHeader> = [
    { text: '', value: 'actions', sortable: false, width: 100 },
    { text: 'タイトル', value: 'name', width: 100 },
    { text: '説明', value: 'description', width: 200 },
    { text: '表示ステータス', value: 'active', width: 100 },
    { text: '更新日時', value: 'updatedAtNumber', width: 100 }
  ]
  recommends: Array<Recommend> = []
  keyword = ''

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'おすすめ求人一覧'
      }
    ]
  }

  mounted(): void {
    super.mounted()
    this.reload()
  }

  async reload(): Promise<void> {
    try {
      this.loading = true
      const recommends = await axios.get<Array<IRecommend>>(apiV1AdminRecommendsPath())
      this.recommends = recommends.data.map(m => new Recommend(m))
      this.loading = false
    } catch (e) {
      console.error(e)
    }
  }

  get viewRecommends(): Array<Recommend> {
    if (this.keyword) {
      const keyword = this.keyword.toLocaleLowerCase()
      return this.recommends.filter(
        recommend => recommend.name.toLocaleLowerCase().includes(keyword) ||
          recommend.description.toLocaleLowerCase().includes(keyword)
      )
    }
    return this.recommends
  }

  async deleteRecommend(id): Promise<void> {
    this.showConfirm({
      title: '削除', message: '選択したおすすめ求人を削除しますか？', onClosed: async (result) => {
        if (result) {
          try {
            await axios.delete(apiV1AdminRecommendPath(id))
            this.showMessage('削除が完了しました')
            await this.reload()
          } catch (e) {
            console.log(e)
          }
        }
      }
    })
  }
}
